import { useEffect } from 'react';
import { io } from 'socket.io-client';

let globalSocket = null;

export const useWebSocket = (existingSocket = null) => {
  // Use existing socket or create a new one if none exists
  if (!globalSocket && !existingSocket) {
    globalSocket = io(process.env.REACT_APP_API_URL);
  }
  const socket = existingSocket || globalSocket;

  useEffect(() => {
    if (!existingSocket) {  // Only set up listeners if we created the socket
      socket.on('connect', () => {
        console.log('WebSocket connected');
      });

      socket.on('disconnect', () => {
        console.log('WebSocket disconnected');
      });

      socket.on('error', (error) => {
        console.error('WebSocket error:', error);
      });

      return () => {
        if (globalSocket) {
          console.log('Cleaning up WebSocket connection');
          globalSocket.disconnect();
          globalSocket = null;
        }
      };
    }
  }, [existingSocket, socket]);

  return { socket };
};